<template>
  <div :class=wrapperClasses>
    <input
      v-bind="$attrs"
      :id="value"
      type="checkbox"
      :value="value"
      :checked="isChecked"
      @change="toggleCheck"
      class="input-checkbox__input form-check-input"
    >
    <label class="input-checkbox form-check-label"
      :for="value"
    >
      <slot/>
    </label>
  </div>
</template>

<script>
  export default {
    model: {
      prop: 'checked',
      event: 'change'
    },
    props: {
      checked: {
        type: [Boolean, Array],
        required: true,
      },
      value: {
        type: [String, Number],
        default: null,
      },
      wrapperClasses: {
        type: String,
        default: 'input-wrapper form-check',
      },
    },
    computed: {
      isChecked() {
        if (Array.isArray(this.checked)) {
          return this.checked.includes(this.value);
        }
        return this.checked;
      }
      },
      methods: {
        toggleCheck(event) {
          let newChecked;
          if (Array.isArray(this.checked)) {
              newChecked = [...this.checked];
              const valueIndex = newChecked.indexOf(this.value);
              if (valueIndex === -1) {
                newChecked.push(this.value);
              } else {
                newChecked.splice(valueIndex, 1);
              }
            } else {
              newChecked = event.target.checked;
            }
            this.$emit('change', newChecked);
        }
      },
  };
</script>

<style lang="scss">
  @import "~styles/definitions";
</style>
